import ProfileStatus from './ProfileStatus.page';

export default ProfileStatus;
